export const getUser = () => {
  try {
    const u = JSON.parse(localStorage.getItem("user"));
    return u?.user || u;
  } catch {
    return null;
  }
};

export const can = (perm) => {
  const u = getUser();
  if (!u) return false;
  if (!u.isStaff) return true;
  return (u.permissions || []).includes(perm);
};

export const canAny = (...perms) => perms.some(can);
export const isOwner = () => !!getUser() && !getUser().isStaff;

const HOME_ORDER = [
  ["factors.view", "/dashboard/factors"],
  ["customers.view", "/dashboard/customers"],
  ["products.view", "/dashboard/products"],
  ["transactions.view", "/dashboard/transactions"],
  ["ledger.view", "/dashboard/ledger"],
  ["letters.view", "/dashboard/letters"],
  ["settings.view", "/dashboard/settings"],
];
export const firstAllowedPath = () =>
  HOME_ORDER.find(([p]) => can(p))?.[1] || null;
